import { WifiOutlined } from '@ant-design/icons'
import { theme } from 'antd'
import dayjs from 'dayjs'
import { PropsWithChildren } from 'react'
import back from './back.png'
import './iPhone15.css'
interface Props {
  link?: string
  background?: string
}
export const Iphone = ({
  link,
  children,
  background,
}: PropsWithChildren<Props>) => {
  const { token } = theme.useToken()
  const textColor = background != undefined ? token.colorText : 'white'
  return (
    <div className="iphone-container" style={{ background: token.colorBgBase }}>
      <div
        className="status-bar"
        style={{
          color: textColor,
          fontWeight: 'bold',
        }}
      >
        <span className="time">{dayjs().format('HH:mm')}</span>
        <div className="network-info">
          <WifiOutlined style={{ fontSize: 18 }} />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            viewBox="0 0 25 25"
            fill="none"
          >
            <rect
              x="20"
              y="4"
              width="3"
              height="16"
              fill={textColor}
              rx="0.5"
            />
            <rect
              x="15"
              y="8"
              width="3"
              height="12"
              fill={textColor}
              rx="0.5"
            />
            <rect
              x="10"
              y="12"
              width="3"
              height="8"
              fill={textColor}
              rx="0.5"
            />
            <rect x="5" y="16" width="3" height="4" fill={textColor} rx="0.5" />
          </svg>
          <span>5G</span>
        </div>
      </div>
      <div className="notch"></div>
      <div
        className="screen"
        style={
          background != undefined
            ? { background: background }
            : { backgroundImage: `url(${back})`, backgroundSize: 'cover' }
        }
      >
        {link && (
          <iframe
            src={link}
            title="iPhone Screen"
            className="iframe-screen"
          ></iframe>
        )}
        {children && children}
      </div>
      <div className="home-indicator"></div>
    </div>
  )
}
